module.exports = __webpack_public_path__ + "img/cliente_tuchip_gris.40bb118a.png";